import React from "react";
import { type BaseButtonProps, Button } from "../button";
import { Icon } from "../icons";

export const MenuButton = React.forwardRef<HTMLButtonElement, BaseButtonProps>((props, ref) => {
	return (
		<Button
			ref={ref}
			size="xxs"
			icon={<Icon name="EllipsisVertical" />}
			variant="ghost"
			{...props}
		/>
	);
});
